import { GetterTree } from 'vuex'
import { RootState } from 'types'
import { ContextState, Errors } from '@/store/context/contextTypes'

export const getters: GetterTree<ContextState, RootState> = {
  context (state): object {
    return state
  },
  config (state): object {
    return state.config
  },
  settings (state): object {
    return state.settings
  },
  userWizardData (state): object {
    return state.userWizardData
  },
  editUserData (state): object {
    return state.editUserData
  },
  didAccessToken (state): string {
    return state.didAccessToken
  },
  editShippingAddressData (state): object {
    return state.editShippingAddressData
  },
  identifyWizardStep (state): number {
    return state.identifyWizardStep
  },
  identifiedUser (state): object | undefined {
    return state.user
  },
  errors (state): Errors {
    return state.errors
  }
}
